'use client';

import { getIsLogin } from 'eco-design-micro/utils-user/web/webToken';
import { useEffect, useState } from 'react';
import HeaderUserLogin from './HeaderUserLogin';
import HeaderUserNone from './HeaderUserNone';

export const HideUserLocaleList = ['cn', 'tw', 'sa'];
export default function UserV1({ prefixCls, className, locale }: { prefixCls: string; className?: string; locale: string }) {
    const [isLogin, setIsLogin] = useState<any>(false);
    useEffect(() => {
        const isLogin2 = getIsLogin();
        setIsLogin(isLogin2);
    }, []);
    if (HideUserLocaleList.includes(locale)) {
        return null;
    }
    return (
        <>
            {isLogin && (
                <>
                    <HeaderUserLogin />
                </>
            )}
            {!isLogin && (
                <>
                    <HeaderUserNone />
                </>
            )}
        </>
    );
}
